import React, { type JSX } from "react";
import { t } from "ttag";

import { interpolate } from "@thelabnyc/thelabui/src/utils/i18n";

import { RatingGraphic } from "../../../common/RatingGraphic";
import { formatNumber } from "../../../utils/format";
import { ReviewsComponentTypes } from "../constants";

interface IProps {
    numReviews: number;
    averageRating: number;
    roundedRating: number;
    reviewsComponentType: ReviewsComponentTypes;
    starHasStroke?: boolean;
}

export function ReviewStarRating(props: IProps): React.ReactNode {
    if (!props.numReviews || props.numReviews <= 0) {
        return null;
    }
    const numReviews = `${formatNumber(props.numReviews)}+ ${
        props.numReviews === 1 ? "REVIEW" : "REVIEWS"
    }`;
    let reviewNumber: JSX.Element | null = null;
    if (props.reviewsComponentType !== ReviewsComponentTypes.CAROUSEL) {
        reviewNumber = (
            <div className="customer-review__number">
                {numReviews}
                <br />
                {interpolate(t`AVERAGE OF %s %s`, [
                    `${props.roundedRating}`,
                    `${props.roundedRating === 1 ? "STAR" : "STARS"}`,
                ])}
            </div>
        );
    } else {
        reviewNumber = (
            <div className="customer-review__number">
                {interpolate(t`(%s OUT OF 5) %s`, [
                    `${props.roundedRating}`,
                    numReviews,
                ])}
            </div>
        );
    }
    return (
        <div className="customer-review__star-rating">
            <div className="customer-review__stars">
                <RatingGraphic
                    cardClass="product-reviews-header"
                    cardSize="large"
                    rating={props.averageRating}
                    onlyStars={true}
                    starHasStroke={props.starHasStroke}
                />
            </div>
            {reviewNumber}
        </div>
    );
}
